<template>
    <layout>
        <template slot="content">
            <header class="content__title">
                <h1>{{ title }}</h1>
            </header>
            <detail :blocks="detailBlocks"></detail>
        </template>
    </layout>
</template>

<script>
    import Layout from '@/layout/Boxed'
    import Detail from '@/components/Detail'
    import Comments from '@/components/Comments'

    export default {
        data() {
            return {
                detailBlocks: []
            }
        },

        props: {
            record: {type: String}
        },

        components: {
            'layout': Layout,
            'detail': Detail,
            'comments': Comments
        },

        computed: {
            title(){
                let title = []
                let nameFields = this.$store.state.structure.modules[this.module].nameFields
                let nameFieldsValue = {}


                for(let key in this.detailBlocks){
                    let fields = this.detailBlocks[key].fields
                    for(let key in fields){
                        let field = fields[key]
                        if($.inArray(field.name, nameFields) > -1){
                            nameFieldsValue[field.name] = field.displayValue
                        }
                    }
                }

                for(let key in nameFields){
                    title.push(nameFieldsValue[nameFields[key]])
                }

                return title.join(' - ')
            }
        },

        watch: {
            async record() {
                this.load()
            },
        },

        methods: {
            async load() {
                let details = await Api.fetchRecord(this.record)
                if(details.result){
                    this.detailBlocks = this.$store.getters.getDetailBlocks({module: this.module, 'details': details.result});
                }
            }
        },

        mounted() {
            this.load()
        }
    }
</script>